// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2wDyd","rightAdornment":"Header_rightAdornment__DA2b9"};